import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import type { JiraStoriesSyncStatus } from '@/domain/models/development.js';

interface Props {
    status: JiraStoriesSyncStatus;
    generatingLabel: string;
    creatingLabel: string;
    waitingLabel: string;
    doneLabel: string;
    retryLabel: string;
    epicUrl?: string | null;
}

export function JiraStoriesStatus({ status, generatingLabel, creatingLabel, waitingLabel, doneLabel, retryLabel, epicUrl }: Props) {
    if (status === 'GENERATING' || status === 'CREATING') {
        return (
            <Box data-testid="jira-stories-status" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <CircularProgress size={14} data-testid="jira-stories-status-loader" />
                <Typography variant="body2">{status === 'GENERATING' ? generatingLabel : creatingLabel}</Typography>
            </Box>
        );
    }
    if (status === 'WAITING_EPIC') {
        return (
            <Typography variant="body2" data-testid="jira-stories-status" sx={{ mb: 2 }}>
                {waitingLabel}
            </Typography>
        );
    }
    if (status === 'RETRYING') {
        return (
            <Typography variant="body2" data-testid="jira-stories-status" sx={{ mb: 2 }}>
                {retryLabel}
            </Typography>
        );
    }
    if (status === 'DONE') {
        return (
            <Typography variant="body2" data-testid="jira-stories-status" sx={{ mb: 2 }}>
                {epicUrl ? (
                    <Link href={epicUrl} target="_blank" rel="noopener noreferrer" data-testid="jira-stories-status-link">
                        {doneLabel}
                    </Link>
                ) : (
                    doneLabel
                )}
            </Typography>
        );
    }
    return null;
}
